import script from "./DEmail.vue?vue&type=script&lang=ts&setup=true"
export * from "./DEmail.vue?vue&type=script&lang=ts&setup=true"

import "./DEmail.vue?vue&type=style&index=0&id=92173ac4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92173ac4"]])

export default __exports__